/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
export const localeOptions = [
    { id: 'en', name: 'English - LTR', direction: 'ltr' },
    { id: 'es', name: 'Español', direction: 'ltr' },
    { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
    apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
    authDomain: 'gogo-react-login.firebaseapp.com',
    databaseURL: 'https://gogo-react-login.firebaseio.com',
    projectId: 'gogo-react-login',
    storageBucket: 'gogo-react-login.appspot.com',
    messagingSenderId: '216495999563',
};

export const navTagInitialStorage = 'initialArrTopNavMenu';
export const navTagArrStorage = 'arrTopNavMenu';

export const searchPath = '/app/pages/search';
//export const servicePath = 'https://apidev.uni2.com.co';
//export const servicePath = 'http://localhost:8000';
export const servicePath = process.env.REACT_APP_API_URL;
export const isProduction =
    process.env.REACT_APP_ENVIRONMENT_NAME === 'PRODUCCION';

export const urlPhotoProfileDefault =
    'https://www.uic.mx/posgrados/files/2018/05/default-user-300x300.png';

/*
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const isMultiColorActive = true;
export const defaultColor = 'light.orange';
export const defaultDirection = 'ltr';
export const isDarkSwitchActive = true;
export const themeColorStorageKey = '__theme_color';
export const themeRadiusStorageKey = '__theme_radius';
export const isDemo = false;
export const iconRequest = 'iconsminds-support';
export const iconClient = 'iconsminds-business-mens';
export const iconReports = 'iconsminds-line-chart-1';
export const iconParameters = 'simple-icon-settings';
export const iconCredit = 'iconsminds-shop-4';
export const iconCalculator = 'simple-icon-calculator';
export const iconReportsDefault = 'iconsminds-pie-chart-3';
export const iconParametersDefault = 'iconsminds-equalizer';
export const iconAffiliate = 'simple-icon-user-follow';
export const iconConcessionaire = 'iconsminds-office';
export const iconCertificate = 'iconsminds-diploma-2';
export const iconPerformanceExcutive = 'iconsminds-line-chart-1';
export const iconSearch = 'iconsminds-magnifi-glass';
export const iconPreAprobador = 'simple-icon-check';
export const iconDigitalSignature = 'iconsminds-pen';
export const iconPerson = 'simple-icon-people';
export const iconNeighborhood = 'simple-icon-location-pin';
export const iconConcessionaireSecondary = 'iconsminds-shop-4';
export const iconPays = 'iconsminds-files';
export const iconZonification = 'iconsminds-map2';
export const simpleIconEye = 'simple-icon-eye';
export const iconUsers = 'simple-icon-user-following';
export const iconDocs = 'iconsminds-library';
export const DocsDesembolsados = 'iconsminds-folder-add--';
export const iconParametersGyg = 'iconsminds-gear';
export const iconEmployeesCredits = 'iconsminds-money-bag';
export const iconSendMsms = 'simple-icon-envelope';
export const iconSendKiva = 'iconsminds-leafs';
export const iconSendPayment = 'iconsminds-mail-attachement';
export const iconMassiveConsult = 'iconsminds-mail-search';
export const iconConsults = 'iconsminds-check';
export const iconPolizas = 'iconsminds-folder';
export const iconAseguradoras = 'iconsminds-file-edit';
export const iconRadication = 'iconsminds-coins';
export const iconOptions = 'iconsminds-file-clipboard-file---text';
export const iconPayment = 'iconsminds-handshake';
export const iconGraphs = 'iconsminds-monitor-analytics';
export const iconCar = 'iconsminds-car';
export const iconAddDocs = 'iconsminds-add-file';
export const iconAddDocsPayment = 'simple-icon-drawer';
export const iconindividual = 'simple-icon-doc';
export const icondual = 'simple-icon-docs';
export const iconWarranty = 'iconsminds-bus-2';
export const iconHandshake = 'iconsminds-handshake';
export const iconFasecolda = 'iconsminds-jeep';
export const iconFinancies = 'iconsminds-financial';
export const iconCreditsMonotoring = 'simple-icon-briefcase';
